import React from 'react';
import { EscortProfile } from '@/types';
import { useTranslation } from 'react-i18next';
import { PersonalInformationSection } from './details-sections/PersonalInformationSection';
import { SexualInformationSection } from './details-sections/SexualInformationSection';
import { LanguagesSection } from './details-sections/LanguagesSection';
import { ContactInformationSection } from './details-sections/ContactInformationSection';
import ProfileAboutMe from './sections/ProfileAboutMe';
import { RatesSection } from './details-sections/RatesSection';

interface ProfileDetailsSectionProps {
  profile: EscortProfile;
  canSeeFullProfile: boolean;
}

export const ProfileDetailsSection = ({ profile, canSeeFullProfile }: ProfileDetailsSectionProps) => {
  const { t } = useTranslation(['common', 'profile']);

  return (
    <>
      <ProfileAboutMe profile={profile} />
      <PersonalInformationSection profile={profile} t={t} />
      <SexualInformationSection profile={profile} canSeeFullProfile={canSeeFullProfile} t={t} />
      <LanguagesSection profile={profile} t={t} />
      {/* Conditionally render ContactInformationSection */} 
      {canSeeFullProfile && (
        <>
          <ContactInformationSection profile={profile} t={t} />
          <RatesSection profile={profile} />
        </>
      )}
    </>
  );
};

